import { Button } from '@framework/ui/atoms/Button';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onSubmit(): Promise<void>;
  onClose(): void;
};

export const StopMailRequestConfirmModal: React.FC<Props> = ({ isOpen, onSubmit, onClose }: Props) => {
  const { t } = useTranslation();
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  const handleSubmit = useCallback(async () => {
    setIsProcessing(true);

    try {
      await onSubmit();
      onClose();
    } finally {
      setIsProcessing(false);
    }
  }, [onClose, onSubmit]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={handleClose}
      title={t('auth.stopMail.confirm.title')}
      submitButton={
        <Button color="danger" onClick={handleSubmit} loading={isProcessing}>
          {t('auth.stopMail.action.stop')}
        </Button>
      }
      cancelButton={
        <Button onClick={handleClose} color="secondary" loading={isProcessing}>
          {t('common.action.cancel')}
        </Button>
      }
    >
      <div className="p-2">
        <div>
          {t('auth.stopMail.confirm.description')}
          <br />
          {t('auth.stopMail.confirm.question')}
        </div>
      </div>
    </GeneralModal>
  );
};
